var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGultkort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.1588,
    cy: 14.0766,
    r: 13.3408,
    fill: "#F9F9F9",
    stroke: "#DCDCDC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1579 20.5724L13.3819 18.9383C13.4785 18.8094 13.4448 18.621 13.3067 18.5175L9.80506 15.8946C9.66693 15.7912 9.47666 15.8118 9.38009 15.9407L8.15608 17.5748",
    stroke: "#323232",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2913 16.2589C11.2531 10.2835 9.66185 11.9158 16.5296 8.481",
    stroke: "#323232",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.727 16.6863L16.806 17.4946C16.9387 17.5939 17.1028 17.6401 17.2622 17.6228C17.4216 17.6055 17.5632 17.5262 17.656 17.4024L21.8526 11.7998C22.0457 11.542 21.9783 11.1652 21.7021 10.9583L17.7003 7.96069C17.424 7.75375 17.0435 7.79503 16.8503 8.05288L12.6537 13.6554C12.5166 13.8384 12.4393 14.1617 12.7373 14.2027L15.4268 12.6576C16.2329 12.1777 17.0169 13.5164 16.2104 13.9967C15.7251 14.2921 15.2791 14.6427 14.881 15.0417C14.6877 15.9077 14.3031 16.7103 13.7535 17.3945L13.054 18.3283",
    fill: "#FDC033"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.727 16.6863L16.806 17.4946C16.9387 17.5939 17.1028 17.6401 17.2622 17.6228C17.4216 17.6055 17.5632 17.5262 17.656 17.4024L21.8526 11.7998C22.0457 11.542 21.9783 11.1652 21.7021 10.9583L17.7003 7.96069C17.424 7.75375 17.0435 7.79503 16.8503 8.05288L12.6537 13.6554C12.5166 13.8384 12.4393 14.1617 12.7373 14.2027L15.4268 12.6576C16.2329 12.1777 17.0169 13.5164 16.2104 13.9967C15.7251 14.2921 15.2791 14.6427 14.881 15.0417C14.6877 15.9077 14.3031 16.7103 13.7535 17.3945L13.054 18.3283",
    stroke: "#323232",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGultkort);
export default __webpack_public_path__ + "static/media/gultkort.33c58ceccbe11e131a535eb7544ebd87.svg";
export { ForwardRef as ReactComponent };